(function () {
  const box = document.getElementById('catQuestionBox');
  if (!box) return;

  const examCategory = box.dataset.examCategory;
  const examDetail = box.dataset.examDetail;
  const nonce = box.dataset.nonce;

  const levelEl = document.getElementById('catLevel');
  const stepEl = document.getElementById('catStep');
  const totalEl = document.getElementById('catTotal');
  const correctEl = document.getElementById('catCorrect');
  const feedbackEl = document.getElementById('catFeedback');

  const restartBtn = document.getElementById('catRestart');

  function setHeader(data) {
    if (levelEl) levelEl.textContent = String(data.level ?? 3);
    if (stepEl) stepEl.textContent = String(data.step ?? 0);
    if (totalEl) totalEl.textContent = String(data.total ?? 20);
    if (correctEl) correctEl.textContent = String(data.correct ?? 0);
  }

  function setFeedback(msg, ok) {
    if (!feedbackEl) return;
    feedbackEl.textContent = msg || '';
    feedbackEl.style.color = ok ? 'green' : 'crimson';
  }

  async function postAjax(action, payload) {
    const fd = new FormData();
    fd.append('action', action);
    fd.append('nonce', nonce);
    fd.append('exam_category', examCategory);
    fd.append('exam_detail', examDetail);

    Object.keys(payload || {}).forEach(k => {
      const v = payload[k];
      if (Array.isArray(v)) {
        v.forEach(x => fd.append(k + '[]', x));
      } else {
        fd.append(k, v);
      }
    });

    const res = await fetch(SPI_QUIZ.ajaxurl, { method: 'POST', body: fd });
    const json = await res.json();
    return json;
  }

  function bindQuestionEvents() {
    const submitBtn = box.querySelector('.js-cat-submit');
    if (!submitBtn) return;

    submitBtn.addEventListener('click', async () => {
      const qWrap = box.querySelector('.quiz-question');
      const qid = qWrap ? qWrap.dataset.qid : null;
      if (!qid) return;

      // choice
      const checks = box.querySelectorAll('.js-cat-answer');
      const inputText = box.querySelector('.js-cat-answer-text');

      let answer = [];
      let answerText = '';

      if (checks && checks.length) {
        answer = Array.from(checks).filter(x => x.checked).map(x => x.value);
        if (!answer.length) {
          setFeedback('回答を選択してください', false);
          return;
        }
      } else if (inputText) {
        answerText = (inputText.value || '').trim();
        if (!answerText) {
          setFeedback('回答を入力してください', false);
          return;
        }
      }

      submitBtn.disabled = true;

      const json = await postAjax('spi_cat_answer', {
        qid: String(qid),
        answer: answer,
        answer_text: answerText,
      });

      if (!json || !json.success) {
        setFeedback('通信エラー / サーバーエラー', false);
        submitBtn.disabled = false;
        return;
      }

      const data = json.data || {};
      setHeader(data);

      if (data.is_correct) setFeedback('正解！', true);
      else setFeedback('不正解', false);

      if (data.finished) {
        box.innerHTML = `
          <div style="padding:16px; border:1px solid #eee; border-radius:14px;">
            <h2>終了</h2>
            <p>正解：${data.correct}/${data.total}</p>
            <p>最終難易度：${data.level}</p>
          </div>
        `;
        return;
      }

      box.innerHTML = data.question_html || '<p>次の問題が取得できません</p>';
      bindQuestionEvents();
      submitBtn.disabled = false;
    });
  }

  async function start() {
    setFeedback('', true);

    const json = await postAjax('spi_cat_start', {});
    if (!json || !json.success) {
      box.innerHTML = '<p>開始できませんでした</p>';
      return;
    }

    const data = json.data || {};
    setHeader(data);

    box.innerHTML = data.question_html || '<p>問題が取得できません</p>';
    bindQuestionEvents();
  }

  async function reset() {
    setFeedback('リセット中...', true);
    const json = await postAjax('spi_cat_reset', {});
    if (!json || !json.success) {
      setFeedback('リセットに失敗', false);
      return;
    }
    setFeedback('リセットしました', true);
    await start();
  }

  if (restartBtn) {
    restartBtn.addEventListener('click', reset);
  }

  start();
})();
